import setFolderViewState from '../actions/setFolderViewState';
import type MailFolderNodeViewState from '../store/schema/MailFolderNodeViewState';
import { getStore } from '../store/store';
import createDragViewState from 'owa-dnd/lib/utils/createDragViewState';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import type { SortBy } from 'owa-mail-list-store';
import { MailSortHelper } from 'owa-mail-list-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export interface GetFolderViewStateFromIdState {
    folderNodeViewStates: Map<string, MailFolderNodeViewState>;
}

export const getFolderViewStateFromIdNoFallback = (
    folderId: string
): MailFolderNodeViewState | undefined => {
    if (isGlobalFeatureEnabled('fp-viewstate-fix')) {
        const viewState = getStore().folderNodeViewStates.get(folderId);
        return viewState;
    } else {
        return getFolderViewStateFromId(folderId);
    }
};

export default function getFolderViewStateFromId(folderId: string): MailFolderNodeViewState {
    const folderViewState = getStore().folderNodeViewStates.get(folderId);

    if (!folderViewState) {
        return getDefaultFolderViewState();
    } else {
        return folderViewState;
    }
}

export const initializeFolderViewStateIfNeeded = (folderId: string): void => {
    if (isGlobalFeatureEnabled('fp-viewstate-fix')) {
        return;
    }
    if (!getStore().folderNodeViewStates.has(folderId)) {
        setFolderViewState(folderId, getDefaultFolderViewState());
    }
};

const getDefaultFolderViewState = () => {
    const defaultSortBy: SortBy = MailSortHelper.getDefaultSortBy();
    return {
        isExpanded: false,
        sortColumn: defaultSortBy.sortColumn,
        sortOrder: defaultSortBy.sortDirection,
        drag: createDragViewState(),
        drop: createDropViewState(),
        color: undefined,
    };
};
